import { evaluateCondition } from "./conditions";

/**
 * Whether a flag descriptor should be rendered given the current context.
 *
 * @param {import("./conditions").FlagDescriptor} descriptor - Flag descriptor.
 * @param {import("./conditions").FlagConditionContext} context - Current flags/app/user values.
 * @returns {boolean} True when the field should be shown.
 */
export const isVisible = (descriptor, context) => evaluateCondition(descriptor.visibleIf, context);

/**
 * Whether a flag descriptor's control should be disabled given the current context.
 *
 * @param {import("./conditions").FlagDescriptor} descriptor - Flag descriptor.
 * @param {import("./conditions").FlagConditionContext} context - Current flags/app/user values.
 * @returns {boolean} True when the control should be disabled.
 */
export const isDisabled = (descriptor, context) =>
  Boolean(descriptor.disabledIf) && evaluateCondition(descriptor.disabledIf, context);
